import {publishKey} from 'a_root-folder/constants';
import HelpService from "service/help.service";
import DetectService from "service/e3.viewer.detect.service";
import {configData} from "service/config.data";

export const connectToServer = (roomID = configData.serverID, clientId) => {
    const detect = DetectService;
    const helpService = new HelpService();
    const uuidUser = helpService.generateUUID();

    const ably = new Ably.Realtime({
        key: publishKey,
        clientId: clientId ? clientId : uuidUser,
        closeOnUnload: !detect.isAndroid,
        recover: false,
        queryTime: true
    });

    const channel =  ably.channels.get(roomID);
    const presence = channel.presence;

    return {ably, channel, presence, uuidUser};
}

export const closeConnection = (ably) => {
    ably.connection.close();
}

export const checkE3liveRestrictions = (channel, config) => {
    return new Promise(async (res, rej) => {
        const participants = await countParticipants(channel);
        if(config.e3live_max_participants <= participants) return res(`Can not join call. Maximum number of participants (${config.e3live_max_participants}) reached`);

        res('');
    })
}

export const countParticipants = (channel) => {
    return new Promise((res, rej) => {
        channel.presence.get((err, occupants) => {
            res(occupants.length);
        });
    })
}

export const findAgents = () => {
    return new Promise((resolve, reject) => {
        const {channel} = connectToServer();
        const {groupIDs} = configData;

        channel.presence.get((err, occupants) => {
            const agents = [];
            var i = occupants.length;
            while (i--) {
                if (occupants[i].data && ['busy', 'offline'].indexOf(occupants[i].data.status) === -1 ) {
                    if(groupIDs.length && !groupIDs.filter(group => occupants[i].data.groupIDs.includes(group)).length) continue;

                    agents.push(occupants[i])
                }
            }
            resolve(agents);
        });
    });
}